"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPreloadingProcess = exports.selectPreloadingProcess = exports.selectMeta = exports.selectItems = exports.selectInRefundProcess = exports.selectInExportProcess = exports.selectCanceledInvoicesInProcess = exports.selectAppliedInvoicesInProcess = exports.resetStateAction = exports.reducer = exports.name = exports.getInvoicesRequestSuccessAction = exports.getInvoicesRequestFailAction = exports.getInvoicesRequestAction = exports.exportInvoicesRequestSuccessAction = exports.exportInvoicesRequestFailAction = exports.exportInvoicesRequestAction = exports.createRefundRequestSuccessAction = exports.createRefundRequestFailAction = exports.createRefundRequestAction = exports.createInvoicesRequestSuccessAction = exports.createCancelRequestSuccessAction = exports.createCancelRequestFailAction = exports.createCancelRequestAction = exports.createAuthRequestSuccessAction = exports.createAuthRequestFailAction = exports.createAuthRequestAction = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _toolkit = require("@reduxjs/toolkit");

var REDUCER_NAME = 'module/invoices';
var INITIAL_STATE = {
  items: [],
  meta: {},
  error: null,
  appliedInvoicesInProcess: [],
  canceledInvoicesInProcess: [],
  inRefundProcess: false,
  inExportProcess: false
};
var slice = (0, _toolkit.createSlice)({
  name: REDUCER_NAME,
  initialState: INITIAL_STATE,
  reducers: {
    resetStateAction: function resetStateAction(state) {
      state['items'] = [];
      state['meta'] = {};
      state['error'] = null;
      state['appliedInvoicesInProcess'] = [];
      state['canceledInvoicesInProcess'] = [];
      state['inRefundProcess'] = false;
      state['inExportProcess'] = false;
    },
    setPreloadingProcess: function setPreloadingProcess(state, _ref) {
      var payload = _ref.payload;
      state['preloadingProcess'] = payload;
    },
    createInvoicesRequestSuccessAction: function createInvoicesRequestSuccessAction(state, _ref2) {
      var payload = _ref2.payload;

      if (state['meta']['paging'] && state['meta']['paging']['skip'] > 0) {
        return void 0;
      }

      state['items'] = [payload].concat((0, _toConsumableArray2["default"])(state['items'].slice(0, 9)));
    },
    getInvoicesRequestAction: function getInvoicesRequestAction(state) {},
    getInvoicesRequestFailAction: function getInvoicesRequestFailAction(state) {},
    getInvoicesRequestSuccessAction: function getInvoicesRequestSuccessAction(state, _ref3) {
      var payload = _ref3.payload;
      state['items'] = payload['data'];
      state['meta'] = payload['meta'];
    },
    exportInvoicesRequestAction: function exportInvoicesRequestAction(state) {
      state['inExportProcess'] = true;
    },
    exportInvoicesRequestFailAction: function exportInvoicesRequestFailAction(state) {
      state['inExportProcess'] = false;
    },
    exportInvoicesRequestSuccessAction: function exportInvoicesRequestSuccessAction(state) {
      state['inExportProcess'] = false;
    },
    createRefundRequestAction: function createRefundRequestAction(state) {
      state['inRefundProcess'] = true;
    },
    createRefundRequestFailAction: function createRefundRequestFailAction(state) {
      state['inRefundProcess'] = false;
    },
    createRefundRequestSuccessAction: function createRefundRequestSuccessAction(state, _ref4) {
      var payload = _ref4.payload;
      state['items'] = state['items'].map(function (item) {
        if (item['id'] === payload['id']) {
          return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, item), {}, {
            status: payload['status'],
            finalAmount: payload['finalAmount']
          });
        }

        return item;
      });
      state['inRefundProcess'] = false;
    },
    createAuthRequestAction: function createAuthRequestAction(state, _ref5) {
      var payload = _ref5.payload;
      state['appliedInvoicesInProcess'] = [].concat((0, _toConsumableArray2["default"])(state['appliedInvoicesInProcess']), [payload]);
    },
    createAuthRequestFailAction: function createAuthRequestFailAction(state, _ref6) {
      var payload = _ref6.payload;
      state['appliedInvoicesInProcess'] = state['appliedInvoicesInProcess'].filter(function (item) {
        return item !== payload;
      });
    },
    createAuthRequestSuccessAction: function createAuthRequestSuccessAction(state, _ref7) {
      var payload = _ref7.payload;
      state['items'] = state['items'].map(function (item) {
        if (item['id'] === payload['id']) {
          return payload;
        }

        return item;
      });
      state['appliedInvoicesInProcess'] = state['appliedInvoicesInProcess'].filter(function (item) {
        return item !== payload['id'];
      });
    },
    createCancelRequestAction: function createCancelRequestAction(state, _ref8) {
      var payload = _ref8.payload;
      state['canceledInvoicesInProcess'] = [].concat((0, _toConsumableArray2["default"])(state['canceledInvoicesInProcess']), [payload]);
    },
    createCancelRequestFailAction: function createCancelRequestFailAction(state, _ref9) {
      var payload = _ref9.payload;
      state['canceledInvoicesInProcess'] = state['canceledInvoicesInProcess'].filter(function (item) {
        return item !== payload;
      });
    },
    createCancelRequestSuccessAction: function createCancelRequestSuccessAction(state, _ref0) {
      var payload = _ref0.payload;
      state['items'] = state['items'].map(function (item) {
        if (item['id'] === payload['id']) {
          return payload;
        }

        return item;
      });
      state['canceledInvoicesInProcess'] = state['canceledInvoicesInProcess'].filter(function (item) {
        return item !== payload['id'];
      });
    }
  }
});
var _slice$actions = slice['actions'],
    resetStateAction = _slice$actions.resetStateAction,
    setPreloadingProcess = _slice$actions.setPreloadingProcess,
    createInvoicesRequestSuccessAction = _slice$actions.createInvoicesRequestSuccessAction,
    getInvoicesRequestAction = _slice$actions.getInvoicesRequestAction,
    getInvoicesRequestFailAction = _slice$actions.getInvoicesRequestFailAction,
    getInvoicesRequestSuccessAction = _slice$actions.getInvoicesRequestSuccessAction,
    exportInvoicesRequestAction = _slice$actions.exportInvoicesRequestAction,
    exportInvoicesRequestFailAction = _slice$actions.exportInvoicesRequestFailAction,
    exportInvoicesRequestSuccessAction = _slice$actions.exportInvoicesRequestSuccessAction,
    createRefundRequestAction = _slice$actions.createRefundRequestAction,
    createRefundRequestFailAction = _slice$actions.createRefundRequestFailAction,
    createRefundRequestSuccessAction = _slice$actions.createRefundRequestSuccessAction,
    createAuthRequestAction = _slice$actions.createAuthRequestAction,
    createAuthRequestFailAction = _slice$actions.createAuthRequestFailAction,
    createAuthRequestSuccessAction = _slice$actions.createAuthRequestSuccessAction,
    createCancelRequestAction = _slice$actions.createCancelRequestAction,
    createCancelRequestFailAction = _slice$actions.createCancelRequestFailAction,
    createCancelRequestSuccessAction = _slice$actions.createCancelRequestSuccessAction;
exports.createCancelRequestSuccessAction = createCancelRequestSuccessAction;
exports.createCancelRequestFailAction = createCancelRequestFailAction;
exports.createCancelRequestAction = createCancelRequestAction;
exports.createAuthRequestSuccessAction = createAuthRequestSuccessAction;
exports.createAuthRequestFailAction = createAuthRequestFailAction;
exports.createAuthRequestAction = createAuthRequestAction;
exports.createRefundRequestSuccessAction = createRefundRequestSuccessAction;
exports.createRefundRequestFailAction = createRefundRequestFailAction;
exports.createRefundRequestAction = createRefundRequestAction;
exports.exportInvoicesRequestSuccessAction = exportInvoicesRequestSuccessAction;
exports.exportInvoicesRequestFailAction = exportInvoicesRequestFailAction;
exports.exportInvoicesRequestAction = exportInvoicesRequestAction;
exports.getInvoicesRequestSuccessAction = getInvoicesRequestSuccessAction;
exports.getInvoicesRequestFailAction = getInvoicesRequestFailAction;
exports.getInvoicesRequestAction = getInvoicesRequestAction;
exports.createInvoicesRequestSuccessAction = createInvoicesRequestSuccessAction;
exports.setPreloadingProcess = setPreloadingProcess;
exports.resetStateAction = resetStateAction;

var selectMeta = function selectMeta(state) {
  return state[REDUCER_NAME]['meta'];
};

exports.selectMeta = selectMeta;

var selectItems = function selectItems(state) {
  return state[REDUCER_NAME]['items'];
};

exports.selectItems = selectItems;

var selectInRefundProcess = function selectInRefundProcess(state) {
  return state[REDUCER_NAME]['inRefundProcess'];
};

exports.selectInRefundProcess = selectInRefundProcess;

var selectInExportProcess = function selectInExportProcess(state) {
  return state[REDUCER_NAME]['inExportProcess'];
};

exports.selectInExportProcess = selectInExportProcess;

var selectAppliedInvoicesInProcess = function selectAppliedInvoicesInProcess(state) {
  return state[REDUCER_NAME]['appliedInvoicesInProcess'];
};

exports.selectAppliedInvoicesInProcess = selectAppliedInvoicesInProcess;

var selectCanceledInvoicesInProcess = function selectCanceledInvoicesInProcess(state) {
  return state[REDUCER_NAME]['canceledInvoicesInProcess'];
};

exports.selectCanceledInvoicesInProcess = selectCanceledInvoicesInProcess;

var selectPreloadingProcess = function selectPreloadingProcess(state) {
  return state[REDUCER_NAME]['preloadingProcess'];
};

exports.selectPreloadingProcess = selectPreloadingProcess;
var name = slice['name'];
exports.name = name;
var reducer = slice['reducer'];
exports.reducer = reducer;